// @ts-nocheck
import React from 'react'
import { withRouter } from 'react-router'
import flow from 'lodash/flow'
import { withLDConsumer, withLDProvider } from 'launchdarkly-react-client-sdk'
import { v4 as uuidv4 } from 'uuid'
import tokens from 'constants/enums/tokens'
import ldFlagNames from 'constants/enums/ldFlagNames'
import MockLDProvider from './MockLDProvider'
import App from './App'
import {
  currentEnvironment,
  PARTNER_HASH_LENGTH,
  getApiHost,
  defaultApiHost
} from './properties/properties'
import RedirectSubdomains from './RedirectSubdomains'
import { BackgroundImageOptions } from '../src/types'

const AppWrapper = ({ flags }) => (
  <div
    id="app-wrapper"
    data-env={currentEnvironment}
    data-api-base-url={getApiHost(currentEnvironment, flags)}
  >
    <RedirectSubdomains />
    <App />
  </div>
)

const { CI, NODE_ENV } = process.env
const withTestSafeLDProvider =
  CI || NODE_ENV === 'test' ? MockLDProvider : withLDProvider

const getPartnerHash = () => {
  const pathArray = window.location.pathname.split('/')
  const partnerHash =
    pathArray[2] && pathArray[2].length === PARTNER_HASH_LENGTH
      ? pathArray[2]
      : null
  return partnerHash
}

export default flow(
  withLDConsumer(),
  withTestSafeLDProvider({
    clientSideID: tokens.launchDarkly,
    user: {
      key: `guest-${uuidv4()}`,
      custom: {
        partnerHash: getPartnerHash()
      }
    },
    flags: {
      [ldFlagNames.maintenanceMode]: false,
      [ldFlagNames.termsOfService]: false,
      [ldFlagNames.salesforceUrl]: defaultApiHost,
      [ldFlagNames.googlePlacesToken]: {},
      [ldFlagNames.redirectSubdomains]: {},
      [ldFlagNames.prospectApplicationBackgroundImage]:
        BackgroundImageOptions.original,
      [ldFlagNames.servicesOfferedForReferralCode]: {}
    }
  }),
  withRouter
)(AppWrapper)
